import React from 'react';
import { Container } from 'react-bootstrap';
import Fade from 'react-reveal/Fade';

const Header = () => {
  return (
    <section id="hero" className="jumbotron">
      <Container>
        <Fade bottom duration={1000} delay={500} distance="30px">
          <h1 className="hero-title">Restack OÜ</h1>
          <p style={{ marginTop: 36 }}>
            <span role="img" aria-label="Wave">
              👋
            </span>{' '}
            <a href="mailto:hello@restack.ee">hello@restack.ee</a>
          </p>
        </Fade>
      </Container>
    </section>
  );
};

export default Header;
